import "../pagesCss/comingSoon.scss";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";

function Formations() {
  const [formdata, setFormdata] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
    sevice: "Formations",
  });

  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);

  const submitHandler = async (event) => {
    event.preventDefault();
    if (!formdata.name) {
      setError(true);
      setMessage("Veuillez renseigner votre nom");
    } else if (!formdata.email) {
      setError(true);
      setMessage("Veuillez renseigner votre Email");
    } else if (!formdata.subject) {
      setError(true);
      setMessage("Veuillez renseigner un objet");
    } else if (!formdata.message) {
      setError(true);
      setMessage("Veuillez saisir votre Message");
    } else {
      setError(false);
      setMessage("Votre message a été reçu!!!");
    }

    setLoading(true);
    try {
      let url = "http://localhost:1337/api/messages";
      const res = await axios.post(url, { data: formdata });
      console.log("data from message post", res.data.data);
      setLoading(false);
    } catch (error) {
      setError(error);
      setLoading(false);
    }
  };

  const handleChange = (event) => {
    setFormdata({
      ...formdata,
      [event.currentTarget.name]: event.currentTarget.value,
    });
  };

  const handleAlerts = () => {
    if (error && message) {
      return <div className="alert alert-danger mt-4">{message}</div>;
    } else if (!error && message) {
      return <div className="alert alert-success mt-4">{message}</div>;
    } else {
      return null;
    }
  };

  return (
    <>
      <div className="container">
        <h1>Devenez employable en moins de 3 mois 👨‍💻</h1>
        {/* <p>
          📢 Bonne nouvelle ! 🚀 Des formations de développement web et mobile
          ainsi que de SEO arrivent bientôt sur notre site! <br /> 🤩 👨‍💻 Envie
          de devenir un développeur backend expérimenté ? 🌐 Les formations en
          Node, Java et PHP sont là pour vous aider à atteindre vos objectifs !
          <br />
          🎨 Plutôt intéressé par le développement frontend ? 🎉 Vous serez ravi
          de savoir que les formations en ReactJS, VueJS, Bootstrap, Tailwind et
          NextJS seront également disponibles très bientôt ! 🙌 <br /> 📱 Vous
          avez toujours voulu apprendre à créer des applications mobiles ? 🔥
          Notre formation en développement mobile avec React Native est là pour
          vous aider à passer de novice à pro ! <br /> 🔍 Et pour couronner le
          tout, nous proposons également une formation en SEO pour aider votre
          site à atteindre les sommets des moteurs de recherche ! 🚀 <br />{" "}
          Rejoignez notre communauté de développeurs passionnés et commencez
          votre voyage vers l'excellence dès maintenant ! 💪 Inscrivez-vous pour
          être les premiers à en profiter ! 📝
        </p> */}
        <p style={{flex:1, alignItems: 'flex-start', alignContent: 'flex-start'}}>
          🎓 Nous sommes ravis de vous présenter Yeduca, une plateforme
          d'apprentissage en ligne de renommée mondiale bientôt disponible 🎓
          <br />
          👨‍🏫 Chez Yeduca, nous croyons que l'apprentissage est la clé du succès,
          et nous sommes actuellement en train de rassembler les meilleurs
          enseignants du monde entier pour vous offrir des cours en ligne de
          qualité supérieure dans une variété de domaines.👩‍🏫
          <br />
          🔜 Nous travaillons dur pour finaliser notre catalogue de cours et
          nous sommes impatients de vous présenter notre sélection de cours dans
          les prochaines semaines. Restez à l'écoute pour être parmi les
          premiers à découvrir Yeduca. 💪
          <br />
          👀 Nous proposerons une large sélection de cours en ligne dans des
          domaines tels que la programmation, le design, le marketing, la
          photographie, le développement personnel et bien plus encore. 🌟
          <br />
          💻 Nos cours seront accessibles 24h/24, 7j/7, sur n'importe quel
          appareil. Que vous soyez chez vous ou en déplacement, vous pourrez
          toujours continuer à apprendre avec Yeduca. 📱💻
          <br />
          🎁 Inscrivez-vous dès maintenant pour être informé de notre lancement
          imminent. Avec Yeduca, vous pourrez devenir la meilleure version de
          vous-même et réussir dans votre vie professionnelle et personnelle. 🚀
        </p>
        {/* <form className="join-wrapper">
          <input type="email" id="email" placeholder="Saisir votre email" />
          <button data-toggle="modal" data-target="#loginModal">
            Yes 💪
          </button>
        </form> */}
        <form
          id="contact-form"
          className="contact-form mt-6"
          onSubmit={submitHandler}
        >
          <div className="row">
            <div className="column col-md-4">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  id="InputName"
                  placeholder="Votre nom"
                  onChange={handleChange}
                  value={formdata.name}
                />
              </div>
            </div>

            <div className="column col-md-4">
              <div className="form-group">
                <input
                  type="email"
                  className="form-control"
                  id="InputEmail"
                  name="email"
                  placeholder="Adresse email"
                  onChange={handleChange}
                  value={formdata.email}
                />
              </div>
            </div>

            <div className="column col-md-4">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  id="InputSubject"
                  name="subject"
                  placeholder="Objet"
                  onChange={handleChange}
                  value={formdata.subject}
                />
              </div>
            </div>
            <div className="row">
              <div className="column col-md-9">
                <div className="form-group">
                  <textarea
                    name="message"
                    id="InputMessage"
                    className="form-control"
                    placeholder="Message"
                    onChange={handleChange}
                    value={formdata.message}
                  ></textarea>
                </div>
              </div>
              <div className="column col-md-12" hidden={true}>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      id="InputSubject"
                      name="service"
                      defaultValue={'formation'}
                      value={formdata.service}
                    />
                  </div>
                </div>
              <div className="column col-md-2">
                <div
                  className="form-group"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <button
                    type="submit"
                    name="submit"
                    id="submit"
                    value="Submit"
                    className="btn btn-default"
                  >
                    Inscription
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
        {handleAlerts()}
      </div>
    </>
  );
}

export default Formations;
